import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-edit\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M16.35,9.84,14.16,7.65,15,6.79a.81.81,0,0,1,1.25,0l.94.94a.81.81,0,0,1,0,1.25Zm-.71.7-7,7H6.5V15.31l7-7Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol